function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M366.071 331.32L258.517 393.222L150.935 331.32V455.098L258.517 517L366.071 455.098L473.626 393.222V269.417L366.071 331.32Z",
  fill: "#EF402C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M318.375 61.8755L210.82 0L103.266 61.8755L210.82 123.778L318.375 185.681V309.459L425.957 247.556V123.778L318.375 61.8755Z",
  fill: "#EF402C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M107.555 238.492L215.136 176.59L107.555 114.687L0 176.59V300.368V424.173L107.582 486.049L107.555 362.271V238.492Z",
  fill: "#EF402C"
});

var SvgCuusooIconPositive = function SvgCuusooIconPositive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 517,
    viewBox: "0 0 474 517",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCuusooIconPositive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cuusoo_icon_positive.33735878.svg";
export { ForwardRef as ReactComponent };